import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { TenantService } from '../services/tenant.service';

export const whitelabelGuard: CanActivateFn = () => {
  const tenantService = inject(TenantService);
  const router = inject(Router);

  // ARC-099: nunca redirecionar para '/' — é a própria rota que este guard
  // protege (path: '', whitelabelGuard). Em modo multitenant, '/' bate de
  // novo nesta rota e neste guard, gerando loop infinito de redirect.
  if (tenantService.mode() !== 'whitelabel') {
    return router.createUrlTree(['/selecionar-tenant']);
  }

  if (!tenantService.hasTenant()) {
    return router.createUrlTree(['/auth/login']);
  }

  return true;
};
